module.exports = __webpack_public_path__ + "img/39aa3.4e4d763a.svg";